import styled from "styled-components";

export const StyledButton = styled.button`
    border: none;
    padding: 0;
    background-color: inherit;
`;

export const NoteMenu = styled.div`
    z-Index: 100;
    margin-top: 0px;
    margin-left: -220px;
    position: relative;
    width: 200px;
    left: 100%;
    border: 1px solid black;
    font-size: 12px;
    text-align: left;
    padding: 10px;
`;

export const NoteMenuItem = styled.div`
    &:hover {
        background-color: #f8f9fa;
    }
`;
